import { motion } from 'framer-motion';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

import classes from './content.module.scss';

const mapAnimation = {
  right: {
    position: 'left',
    dimension: 'width',
  },
  left: {
    position: 'right',
    dimension: 'width',
  },
  down: {
    position: 'top',
    dimension: 'height',
  },
  up: {
    position: 'bottom',
    dimension: 'height',
  },
};

function Content({
  isOpen,
  direction,
  animationDuration,
  animationDelay,
  children,
}) {
  const ref = useRef();

  const [contentDimension, setContentDimension] = useState();

  useEffect(() => {
    setContentDimension(ref.current[`scroll${_.capitalize(dimension)}`]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);

  const { position, dimension } = mapAnimation[direction];

  const containerVariants = {
    open: {
      // [dimension]: contentDimension ? contentDimension : 'auto',
      [dimension]: 'auto',
      transition: {
        delay: animationDelay,
        duration: animationDuration,
      },
    },
    closed: {
      [dimension]: 0,
      transition: {
        delay: animationDelay,
        duration: animationDuration,
      },
    },
  };

  const contentVariants = {
    open: {
      opacity: 1,
      [position]: 0,
      transition: {
        delay: animationDelay,
        duration: animationDuration,
      },
    },
    closed: {
      opacity: 0,
      [position]: contentDimension ? -contentDimension : '-200vw',
      transition: {
        delay: animationDelay,
        duration: animationDuration,
      },
    },
  };

  return (
    <motion.div
      variants={containerVariants}
      initial={false}
      animate={isOpen ? 'open' : 'closed'}
    >
      <motion.div
        className={classes.content}
        initial={false}
        variants={contentVariants}
        animate={isOpen ? 'open' : 'closed'}
        ref={ref}
      >
        {children}
      </motion.div>
    </motion.div>
  );
}

Content.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  direction: PropTypes.oneOf(['up', 'right', 'down', 'left']).isRequired,
  animationDuration: PropTypes.number.isRequired,
  animationDelay: PropTypes.number.isRequired,
  children: PropTypes.node,
};

Content.defaultProps = {
  isOpen: false,
  direction: 'down',
  animationDuration: 0.4,
  animationDelay: 0,
};

export default Content;
